
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {},
})
export default class ButtonRenderer extends Vue {}
